module.exports = __webpack_public_path__ + "img/price-2.ea514b66.png";